export const isEmptyString = (str?) => {
	return !str || (str + '').replace(/\s/g, '') === '';
};
